import type { RoleConfig } from '../types.js';

export const jester: RoleConfig = {
  id: 'jester',
  faction: 'solo',
  title: { ru: 'Шут', uk: 'Блазень' },
  latin: 'JESTER',
  number: '28',
  accent: '#ff7ad6',
  ability: {
    ru: 'Каждую ночь может «дразнить» — следующей ночью на проверках выглядит мафией. Побеждает в одиночку, если его повесят дневным голосованием.',
    uk: 'Щоночі може «дражнити» — наступної ночі на перевірках виглядає мафією. Перемагає на самоті, якщо його повісять денним голосуванням.',
  },
  abilities: [
    { key: 'taunt', phase: 'night', cadence: 'every-night', shape: 'targetless', targetless: true },
  ],
  victory: { type: 'solo-voted-out' },
};
